import { combineReducers } from 'redux';
import list from './list';
import create from './create';
import update from './update';
import del from './delete';
import show from './show';
import available from './available';
import picked from './picked';

export default combineReducers({
    list,
    create,
    update,
    del,
    show,
    available,
    picked
});



// WEBPACK FOOTER //
// ./src/reducers/song/index.js